import React from "react";
import { styled } from "@mui/material/styles";
import { Grid } from "@mui/material";
// eslint-disable-next-line import/no-cycle
import PTMInput from "./PTMInput";

const Root = styled("div")(() => ({
    "& .MuiFormControl-root": {
        width: "100%",
    },

    "&>.MuiGrid-root": {
        marginBottom: 10,
    },

    "&>.MuiGrid-root>.MuiGrid-item": {
        padding: 5,
    },
}));

export default function PTMInputContainer(props) {
    const {
        inputs,
        wrapperSx,
        containerSx,
        itemSx,
        inputConditions,
        generator,
    } = props;

    const inputGenerator = (
        {
            name,
            type,
            tabId,
            size,
            sx,
            label,
            disabled,
            hide,
            multiline,
            freeSolo,
            rows,
            options,
            optionsKey,
            optionsName,
            optionsFilter,
            optionsValueType,
            labelFormat,
            optionsFormat,
            allowEmpty,
            noForm,
            required,
            inputProps,
            onClick,
            onChange,
            onBlur,
            inputLink,
            fullHeight,
            getOptions,
            getSelectedOption,
            value,
            defaultValue,
            onClear,
            key,
            trueLabel,
            falseLabel,
            validate,
            maxValue,
            minValue,
            marks,
            startAdornment,
            endAdornment,
            onKeyDown,
        },
    ) => (
        <Grid item xs={size || 12} sx={{ ...itemSx, ...sx, display: hide ? "none" : "" }} key={key || name}>
            {type === "label" ? (
                <span>{label}</span>
            ) : (
                <PTMInput
                    type={type}
                    tabId={tabId}
                    sx={inputConditions?.sx || sx}
                    freeSolo={freeSolo}
                    options={options}
                    optionsKey={optionsKey}
                    optionsName={optionsName}
                    optionsFilter={optionsFilter}
                    optionsValueType={optionsValueType || "key"}
                    labelFormat={labelFormat}
                    optionsFormat={optionsFormat}
                    inputProps={inputConditions?.inputProps || inputProps}
                    required={required}
                    label={label}
                    multiline={multiline}
                    rows={rows}
                    name={name}
                    disabled={inputConditions?.disabled || disabled}
                    noForm={inputConditions?.noForm || noForm}
                    allowEmpty={inputConditions?.allowEmpty || allowEmpty}
                    onClick={onClick}
                    onChange={onChange}
                    onBlur={onBlur}
                    inputLink={inputLink}
                    fullHeight={fullHeight}
                    getOptions={getOptions}
                    getSelectedOption={getSelectedOption}
                    value={value}
                    defaultValue={defaultValue}
                    onClear={onClear}
                    trueLabel={trueLabel}
                    falseLabel={falseLabel}
                    validate={validate}
                    maxValue={maxValue}
                    minValue={minValue}
                    marks={marks}
                    startAdornment={startAdornment}
                    endAdornment={endAdornment}
                    onKeyDown={onKeyDown}
                />
            )}
        </Grid>
    );

    return (
        <Root style={wrapperSx}>
            <Grid container sx={containerSx}>
                { generator

                    ? generator.map((input) => (
                        inputGenerator(input)
                    ))

                    : inputs?.map((input) => (
                        <Grid item xs={input.size || 12} sx={{ ...itemSx, ...input.sx }}>
                            {input.input}
                        </Grid>
                    ))}
            </Grid>
        </Root>
    );
}
